var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_542_7422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.66699 3.33333H1.33366C1.15685 3.33333 0.987279 3.40357 0.862254 3.52859C0.73723 3.65361 0.666992 3.82318 0.666992 3.99999V8.66666C0.666992 8.84347 0.73723 9.01304 0.862254 9.13807C0.987279 9.26309 1.15685 9.33333 1.33366 9.33333H6.00033C6.17714 9.33333 6.34671 9.26309 6.47173 9.13807C6.59675 9.01304 6.66699 8.84347 6.66699 8.66666V6.33333M6.16699 2.83333C6.2996 2.70072 6.47946 2.62622 6.66699 2.62622C6.85453 2.62622 7.03438 2.70072 7.16699 2.83333C7.2996 2.96594 7.3741 3.14579 7.3741 3.33333C7.3741 3.52086 7.2996 3.70072 7.16699 3.83333L4.00033 6.99999L2.66699 7.33333L3.00033 5.99999L6.16699 2.83333Z",
    stroke: "#505363",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_542_7422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(0 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.bb4af62642e77edfe282281cd9b9ee6c.svg";
export { ForwardRef as ReactComponent };